import React, { createContext, useCallback, useContext, useState } from 'react';

const LoadingContext = createContext();

export function LoadingProvider({ children }) {
  const [loadingDone, setLoadingDone] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const startLoading = useCallback(() => {
    setLoadingDone(false);
  }, []);

  const finishLoading = useCallback(() => {
    setLoadingDone(true);
  }, []);

  const startLogout = useCallback(() => {
    setIsLoggingOut(true);
    setLoadingDone(false);
  }, []);

  const finishLogout = useCallback(() => {
    setIsLoggingOut(false);
    setLoadingDone(true);
  }, []);

  return (
    <LoadingContext.Provider value={{
      loadingDone,
      isLoggingOut,
      startLoading,
      finishLoading,
      startLogout,
      finishLogout
    }}>
      {children}
    </LoadingContext.Provider>
  );
}

export function useLoading() {
  const context = useContext(LoadingContext);
  if (context === undefined) {
    throw new Error('useLoading must be used within a LoadingProvider');
  }
  return context;
}
